import React from 'react';

import styles from './styles.module.scss';
import {Hero} from './Hero';
import {FAQ} from '../../components/FAQ';

export const Premium = () => {
  return (
    <div className={styles.premium}>
      <div className={styles.container}>
        <Hero />
        <div className={styles.frequently}>
          <FAQ />
        </div>
      </div>
    </div>
  );
};
